export const postTestResultConfigs = {
    EXCELLENT : "Excellent",
    VERY_GOOD : "Very Good",
    GOOD : "Good",
    POOR : "Poor"
}

export function formatCompletionDate(dateString) {

    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}

export function getScore(result){
    if(result === "Excellent"){
        return "90-100";
    }
    else if(result === "Very Good"){
        return "80 - 90"
    }
    else if(result === "Good"){
        return "60-80"
    }
    else if(result === "Poor"){
        return "<60"
    }
}